export default {
  descriptionColor: '',
  disclaimerTextCssColor: Styles.color.black,
  emptyStateBodyColor: '',
  headingTextTransform: 'uppercase',
  pCssColor: Styles.color.black,
  textColor: '',
};
